import { KpiType } from '../../coaching-insight/insight-widget/model/kpi-type.model';
import { prepareMetricPerformanceData } from '../functions/get-card-row-data.function';
import { CardRowData } from '../models/card-row-data.model';
import { MyCoachingCard } from '../models/my-coaching-card.model';
import { OaScoreType } from '../models/oa-score-type.enum';
import { StagingKpiThreshold } from '../models/staging-kpi-threshold.model';

export function getCardRowsData(
    card: MyCoachingCard,
    coachingCardThreshold: StagingKpiThreshold[],
    isTypeFloa?: boolean,
    superGroupScore?: number,
): CardRowData[] {
    const cardRows: CardRowData[] = [];
    card.oaSummary
        .filter((row) => row.type === OaScoreType.OA)
        .forEach((e) => {
            cardRows.push({
                id: isTypeFloa === true ? KpiType.FRONT_LINE_OA : e.type,
                metricPerformanceData: prepareMetricPerformanceData(
                    e,
                    coachingCardThreshold,
                    isTypeFloa,
                    superGroupScore,
                ),
            });
        });

    return cardRows;
}
